module.exports = __webpack_public_path__ + "static/img/fail-icon.9542b71f.svg";